export enum UserDataTypes {
  title = 1,
  firstName = 2,
  lastName = 3,
  role = 4,
  email = 5,
}
